import Joi from '@hapi/joi';
// Note: These constants are now loaded dynamically from Redux state
// For static validation, we'll use a broader set of valid values
const VALID_WEATHER_CONDITION_TYPE = [
    'Rain',
    'Sunny',
    'Temperature',
    'FeelsLike',
    'Snow',
    'humidity',
    'windspeed',
    'heat',
    'haze',
    'fog',
    'iceWarning',
    'freezingRain',
    'pollen',
    'airquality',
    'flu',
    'uv',
    'mosquito',
    'tick',
    'migraine',
    'outdoor',
    'pool',
    'beach',
    'poolandbeach',
    'ski',
];

const VALID_WEATHER_CONDITION_QUALIFIER = [
    'equal',
    'greaterThan',
    'lessThan',
    'greaterThanInclusive',
    'lessThanInclusive',
];

const schema = Joi.array()
    .items(
        Joi.object({
            type: Joi.string().when('isDefault', {
                is: true,
                then: Joi.allow(''),
                otherwise: Joi.string()
                    .required()
                    .valid(...VALID_WEATHER_CONDITION_TYPE),
            }),
            qualifier: Joi.string().when('isDefault', {
                is: true,
                then: Joi.allow(''),
                otherwise: Joi.string()
                    .required()
                    .valid(...VALID_WEATHER_CONDITION_QUALIFIER),
            }),
            amount: Joi.number()
                .when('isDefault', {
                    is: true,
                    then: Joi.allow(-1),
                })
                .when('type', {
                    is: 'Temperature',
                    then: Joi.number()
                        .integer()
                        .required(),
                    otherwise: Joi.number().required(),
                })
                .when('type', {
                    is: 'FeelsLike',
                    then: Joi.number()
                        .integer()
                        .required(),
                    otherwise: Joi.number().required(),
                }),
            markupId: Joi.string().required(),
            id: Joi.string().required(),
            isDefault: Joi.boolean().required(),
        })
    )
    .optional();

export default schema;
